import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class LeadTaxpayerIdentificationNumberValidationResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                taxpayer_identification_number: '30703078121',
                business_name: 'SAPORE DI PANE S. A.',
                is_found_in_arca: true,
                is_active_in_arca: true,
                customer_status: 'NEW_CUSTOMER',
            },
            errors: [],
        };
    }

    taxpayerIdentificationNumber() {
        return this.content().taxpayer_identification_number;
    }

    businessName() {
        return this.content().business_name;
    }

    isFoundInArca() {
        return this.content().is_found_in_arca;
    }

    isActiveInArca() {
        return this.content().is_active_in_arca;
    }

    customerStatus() {
        return this.content().customer_status;
    }

    belongsToAnActiveCustomer() {
        return this.customerStatus() === 'ACTIVE_CUSTOMER';
    }
}
